import { createContext } from 'react';

const DisclaimerContext = createContext();

export default DisclaimerContext;
